import Radio from '../../design-system/radio';
import Selectors from '../above-the-fold/selectors';
import ButtonHandler from './button-handler';

import { RADIO_SELECTOR } from '../../classnames/design-system';
import { SUBSCRIPTION_INPUT_NAME } from '../../classnames/above-the-fold';

export default class SubscriptionHandler {
  constructor(container) {
    this.container = container;
    this.buttonHandler = new ButtonHandler();
    this.radioButton = new Radio();
  }

  selectors = (container) => new Selectors(container);

  handle = ({ subscription }) => {
    const subscriptionRadios = [
      ...this.container.querySelectorAll(`${RADIO_SELECTOR}[value="${subscription}"]`)
    ];

    subscriptionRadios.forEach((radio) => {
      this.radioButton.removeSelection(radio, this.container);
      this.radioButton.addSelection(radio, this.container);
    });

    this.runHandlers(this.container);
  };

  runHandlers = (container) => {
    const { variantId } = container.dataset;
    const variantData = window.variantDataSelector.getData(variantId);
    const { subscription } = window.currentVariantStorage.getState();

    if (variantData) {
      this.buttonHandler.handle({ ...variantData, subscription }, container);
    }
  };

  handleClick = ({ target }) => {
    const subscription = target.getAttribute('value');

    window.currentVariantStorage.setSubscription(subscription);
  };

  initializeEventListeners = () => {
    const subscriptionSelectors = this.container.querySelectorAll(
      `${RADIO_SELECTOR}[name="${SUBSCRIPTION_INPUT_NAME}"]`
    );

    [...subscriptionSelectors].forEach((element) => {
      element.addEventListener('click', this.handleClick);
    });

    window.currentVariantStorage.subscribe(this);
  };
}
